import { getAPIErrorMessage } from 'api';
export const openProPopup = (text) => ({
    type: 'OPEN_PRO_POPUP',
    text,
});
export const closeProPopup = () => ({
    type: 'CLOSE_PRO_POPUP',
});
export const applyEmailConfirmed = () => ({ type: 'APPLY_EMAIL_CONFIRMED' });
export const setEmailOk = (email) => ({ type: 'SET_EMAIL__OK', email });
export function getAccount() {
    return async (dispatch, getState, { api }) => {
        dispatch({ type: 'GET_ACCOUNT__REQUEST' });
        try {
            const response = await api.get_account();
            dispatch({
                type: 'GET_ACCOUNT__OK',
                account: response.account,
            });
        }
        catch (e) {
            const error = getAPIErrorMessage(e, 'Не удалось обновить аккаунт');
            dispatch({ type: 'GET_ACCOUNT__FAIL', error });
        }
    };
}
